import { useRoute } from 'vue-router'
// 获取页面的参数
export default function () {
  let $route = useRoute()
  return {
    detailsId: $route.params.detailsId, // 详情id
    navId: $route.params.navId // 导航id
  }
}
